/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum UnitEnumResponse {
    SQUARE_FEET = 'SquareFeet',
    INCHES = 'Inches',
    METERS = 'Meters',
    CENTIMETERS = 'Centimeters',
    CUBIC_METERS = 'CubicMeters',
    SQUARE_METERS = 'SquareMeters',
    FEET = 'Feet',
    PERCENTAGES = 'Percentages',
    PIECES = 'Pieces',
    CUBIC_FEET = 'CubicFeet',
}